<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="mb-5x">
    <div class="d-flex justify-content-between">
      <h2
        class="mb-3x">{{ pageTitle | translate }}
      </h2>
    </div>
    <common-ui-juristische-person
      [affectNavigationInfo]=true
      [(data)]="data.juristischePerson" [readonly]="readonly"
      [stammdatenFirmenname]="stammdaten?.unternehmen?.firmenname">
    </common-ui-juristische-person>
  </div>

  <div class="mb-5x">
    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ADRESSE.ADRESSE_TITEL' | translate }}</h2>
    <common-ui-adresserfassung
      [(auslandsadresse)]="data.auslandsadresse"
      [(inlandsadresse)]="data.inlandsadresse"
      [(postfachadresse)]="data.postfachadresse"
      [readonly]="readonly"
      [stammdatenAuslandsAdresse]="stammdaten?.unternehmen?.auslandsadressen?.array"
      [stammdatenInlandsadresse]="stammdaten?.unternehmen?.inlandsadressen?.array"
      [stammdatenPostfachadresse]="stammdaten?.unternehmen?.postfachadressen?.array">
    </common-ui-adresserfassung>
  </div>

  <div *ngIf="isKapGes" class="mb-5x">
    <common-ui-ort-des-sitzes
      [(data)]="ortDesSitzes" [readonly]="readonly" [stammdatenOrtDesSitzes]="stammdaten?.unternehmen?.ortDesSitzes">
    </common-ui-ort-des-sitzes>
  </div>

  <div class="mb-5x">
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.KOMMUNIKATIONSMITTEL.KOMMUNIKATIONSMITTEL_TITEL' | translate }}</h2>
    <common-ui-kommunikationsmittel
      [(data)]="data.kommunikationsmittel" [readonly]="readonly"
      [stammdatenInternetadressen]="stammdaten?.unternehmen?.kommunikation?.internetadressen?.array"
      [stammdatenTelefonnummern]="stammdaten?.unternehmen?.kommunikation?.telefonnummern?.array"
      maxTelefonnummern="2">
    </common-ui-kommunikationsmittel>
  </div>

  <div class="mb-5x">
    <h2 class="mb-3x">
      {{ 'COMMON_UI.FRAGEBOGEN.TAETIGKEITSART.TITEL' | translate }}
    </h2>
    <common-ui-taetigkeitsart
      [(data)]="data.taetigkeit" [readonly]="readonly">
    </common-ui-taetigkeitsart>
  </div>

</form>
